import { get, post, deleteFun, upload, put } from '@/utils/request.js';


// 岗位管理

/**
 * 岗位列表
 * pageNum
 * pageSize
 */
export function getPostList(params) {
    return get('/mpp/post/findList', params);
}

/**
 * 岗位详情
 * id
 */
export function getPostById(params) {
    return get('/mpp/post/get', params);
}

/**
 * 添加岗位
 * id
 */
export function addPost(params) {
    return post('/mpp/post/add', params);
}

/**
 * 修改岗位
 * id
 */
export function editPost(params) {
    return post('/mpp/post/edit', params);
}

/**
 * 删除岗位
 * ids 支持批量删除
 */
export function deletePost(params) {
    return deleteFun('/mpp/post/delete', params);
}

/**
 * 获取用户岗位信息
 * @param {*} params 
 * @returns 
 */
export function findUsersByPostId(params){
    return get('/mpp/post/findUsersByPostId',params)
}

/**
 * 删除用户岗位信息
 * @param {*} params 
 * @returns 
 */
export function deleteUserFromPost(params){
    return deleteFun('/mpp/post/deleteUserFromPost',params)
}

export function addUserListByPostId(params){
    return post('/mpp/post/addUsersIntoPost',params)
}


